import {Injectable} from '@angular/core';
import {Address, AddressType, CommonTransformationService, QueryResult} from "@app/shared";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {SelectItem} from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http: HttpClient, private transform: CommonTransformationService) {
  }

  // FixMe jC: 1.3 location is used for both procurement and sales order, need to change the url
  getLocationAddress(addressType?: AddressType): Observable<QueryResult> {
    let url = `/procurement/locations/search`;
    if (addressType) {
      url += `?addrType=${addressType}`;
    }
    return this.http.get<QueryResult>(url);
  }

  getLocationAddressAsDropdown(addressType: AddressType, labelProperty?: string, idAsValue?: boolean): Observable<SelectItem<Address | number>[]> {
    return this.getLocationAddress(addressType).pipe(map(res => {
      labelProperty = labelProperty ? labelProperty : "addrName";
      if (idAsValue) {
        return <SelectItem<number>[]>this.transform.convertToDropDown(labelProperty, res.list, "id", true);
      } else {
        return <SelectItem<Address>[]>this.transform.convertToDropDown(labelProperty, res.list, null, true);
      }
    }));
  }
}
